import { useContext, useState } from 'react';
import Spinner from '../../../reusable/spinner/spinner.component';
import { ToastContext } from '../../../../contexts/toast.context';
import Client from '../../../../tools/client';

import {
  AddShippingButton,
  AddShippingContainer,
  AddShippingInput,
  NewShippingContainer
} from './add-shipping-type.styles';

const client = new Client();

const AddShippingType = () => {
  const [name, setName] = useState('');
  const [speedDays, setSpeedDays] = useState('');
  const [loading, setLoading] = useState(false);

  const { errorToast, successToast } = useContext(ToastContext);

  const addShippingType = async () => {
    if (!name) {
      errorToast('Name is required.');
      return;
    }

    setLoading(true);

    const res = await client.createShippingType({
      name,
      speedDays: speedDays ? parseInt(speedDays, 10) : null
    });

    if (res.status === 400 || res.error) {
      setLoading(false);
      errorToast(res.message || 'Failed to create shipping type');
      return;
    }

    successToast('Shipping type created');
    window.location.reload();
  };

  return (
    <AddShippingContainer>
      {loading ? (
        <Spinner />
      ) : (
        <NewShippingContainer>
          <AddShippingInput
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Type Name (e.g. 'Ground', '2-Day')"
          />

          <AddShippingInput
            type="number"
            name="speedDays"
            value={speedDays}
            onChange={(e) => setSpeedDays(e.target.value)}
            placeholder="Speed (in days, optional)"
          />

          <AddShippingButton onClick={addShippingType}>Add Shipping Type</AddShippingButton>
        </NewShippingContainer>
      )}
    </AddShippingContainer>
  );
};

export default AddShippingType;